import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "mt-8" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "text-xl font-semibold leading-tight text-gray-700" }
const _hoisted_5 = { class: "flex flex-col mt-3 sm:flex-row justify-between" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: 5 }, "5", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: 10 }, "10", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: 20 }, "20", -1)
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-4 h-4 fill-current",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" })
  ])
], -1)
const _hoisted_14 = { class: "relative block mt-2 sm:mt-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "absolute inset-y-0 left-0 flex items-center pl-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    class: "w-4 h-4 text-gray-500 fill-current"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z" })
  ])
], -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Add ")
const _hoisted_17 = { class: "px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8" }
const _hoisted_18 = { class: "inline-block min-w-full overflow-hidden rounded-lg shadow" }
const _hoisted_19 = { class: "min-w-full leading-normal" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " Nama "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " NIM "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " Program Studi "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " Jenis Bantuan "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " Bulan "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " Tahun "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " Jumlah Donasi "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " Settings ")
  ])
], -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "20",
  class: "px-5 py-5 text-sm bg-white border-b border-gray-200"
}, " Loading... ", -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_25 = { class: "text-gray-900 whitespace-nowrap" }
const _hoisted_26 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_27 = { class: "text-gray-900 whitespace-nowrap" }
const _hoisted_28 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_29 = { class: "text-gray-900 whitespace-nowrap" }
const _hoisted_30 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_31 = { class: "text-gray-900 whitespace-nowrap" }
const _hoisted_32 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_33 = { class: "text-gray-900 whitespace-nowrap" }
const _hoisted_34 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_35 = { class: "text-gray-900 whitespace-nowrap" }
const _hoisted_36 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_37 = { class: "text-gray-900 whitespace-nowrap" }
const _hoisted_38 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_39 = { class: "flex justify-around" }
const _hoisted_40 = { class: "text-yellow-500 flex justify-center" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "flex flex-col items-center xs:flex-row xs:justify-between sticky bottom-0" }
const _hoisted_44 = { class: "flex flex-col items-center bg-white rounded p-2" }
const _hoisted_45 = { class: "text-xs text-gray-900 xs:text-sm" }
const _hoisted_46 = { class: "inline-flex mt-2 xs:mt-0" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]

import { ref, computed, onMounted } from 'vue';
  import { GET_DANA_BANTUAN, DELETE_DANA_BANTUAN } from "@/store/danaBantuan.module";
  import ModalForm from "../components/modal/FormDanaBantuan.vue";
  import { useStore } from 'vuex'; // Impor useStore dari Vuex
  import Breadcrumb from '../partials/AppBreadcrumb.vue';
  import Swal from 'sweetalert2';
  import { formattedPrice } from '@/utils';
  import IcTrash from '@/assets/svg/ic-trash.vue';
  import IcEdit from '@/assets/svg/ic-edit.vue';
import IcPlus from '@/assets/svg/ic-plus.vue';
  
  // Mengambil data tabel
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const store = useStore(); // Mengambil instance store
  
  const isOpened = ref(false); 
  const isLoading = ref(true); 
  const isGenerateOpened = ref(false); 
  const dataUpdate = ref([]); 
  const currentId = ref(undefined); 
  const isImageModalOpen = ref(false);
  const selectedImage = ref('');
  const page = ref(1);
  const limit = ref(5);
  const search = ref("");
  const title = ref("Dana Bantuan");
  
  const openModal = () => {
    isOpened.value = true; // Open the modal
  };
  
  const handleModalClose = async () => {
    isOpened.value = false; // Close the modal
    isGenerateOpened.value = false; // Open the modal
    dataUpdate.value = [];
    currentId.value = undefined
    await getData();
    // Emit an event if needed, e.g., refreshing data
  
  };
  
  // Contoh penggunaan computed
  const computedData = computed(() => {
    const data = store.getters.danaBantuan; // Menggunakan store di sini
    return data.data || []; // Menghindari undefined
  });
  
  const pagination = computed(() => {
    const data = store.getters.danaBantuan; // Menggunakan store di sini
    return data?.pagination || []; // Menghindari undefined
  });
  
  // Fungsi untuk mengambil data
  const getData = async () => {
    const params = {
      data:{
        search: search.value,
        limit: limit.value,
        page: page.value,
      } 
    };
    const data = await store.dispatch(GET_DANA_BANTUAN, params);
    isLoading.value = false;
    return data;
  };
  
  // Contoh penggunaan onMounted
  onMounted(async () => {
    await getData(); // Memanggil fungsi untuk mengambil data
  });

  const closeImageModal = () => {
        isImageModalOpen.value = false;
  }
  
  // Inside <script setup>
  const editItem = (item:any) => {
    dataUpdate.value = { ...item }; // Copy current item's data to dataUpdate
    currentId.value = item.id; 
    isOpened.value = true; // Open the modal
  };
  
  const deleteItem = async (id: number) => {
     await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
            if (result.isConfirmed) {
              const params = { id: id };
              await store.dispatch(DELETE_DANA_BANTUAN, params);
              try {
                Swal.fire({
                  title: "Deleted!",
                  text: "Your item has been deleted.",
                  icon: "success",
                  confirmButtonColor: '#4CAF50',  // Change the color of the "OK" button
                  confirmButtonText: "OK"
                }).then(async () => {
                  await getData();
                });
              } catch (err) {
                console.log(err);
              }
            }
          });
  };
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Breadcrumb, { breadcrumb: title.value }, null, 8, ["breadcrumb"]),
    (isOpened.value)
      ? (_openBlock(), _createBlock(ModalForm, {
          key: 0,
          id: currentId.value,
          title: `${currentId.value? 'Edit' : 'Add'} ${title.value}`,
          data: dataUpdate.value,
          onClose: handleModalClose
        }, null, 8, ["id", "title", "data"]))
      : _createCommentVNode("", true),
    (isImageModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: closeImageModal,
          class: "fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
        }, [
          _createElementVNode("img", {
            src: selectedImage.value,
            alt: "Payment Image",
            class: "max-w-full max-h-full"
          }, null, 8, _hoisted_1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(title.value), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("select", {
                  class: "block w-full h-full px-4 py-2 pr-8 leading-tight text-gray-700 bg-white border border-gray-400 rounded-l appearance-none focus:outline-none focus:bg-white focus:border-gray-500",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((limit).value = $event)),
                  onChange: getData
                }, _hoisted_12, 544), [
                  [_vModelSelect, limit.value]
                ]),
                _hoisted_13
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                placeholder: "Search",
                class: "block w-full py-2 pl-8 pr-6 text-sm text-gray-700 placeholder-gray-400 bg-white border border-b border-gray-400 rounded-l rounded-r appearance-none sm:rounded-l-none focus:bg-white focus:placeholder-gray-600 focus:text-gray-700 focus:outline-none",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                onInput: getData
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "flex justify-between items-center px-4 py-2 font-medium tracking-wide text-white capitalize transition-colors duration-200 transform bg-blue-600 rounded-md hover:bg-blue-500 focus:outline-none focus:bg-blue-500",
            onClick: openModal
          }, [
            _createVNode(IcPlus),
            _hoisted_16
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("table", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("tbody", null, [
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_21, _hoisted_23))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(computedData), (u, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_24, [
                          _createElementVNode("p", _hoisted_25, _toDisplayString(u?.penerima?.nama), 1)
                        ]),
                        _createElementVNode("td", _hoisted_26, [
                          _createElementVNode("p", _hoisted_27, _toDisplayString(u?.penerima?.nim), 1)
                        ]),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("p", _hoisted_29, _toDisplayString(u?.penerima?.program_studi), 1)
                        ]),
                        _createElementVNode("td", _hoisted_30, [
                          _createElementVNode("p", _hoisted_31, _toDisplayString(u?.jenis_bantuan), 1)
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("p", _hoisted_33, _toDisplayString(u?.bulan), 1)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("p", _hoisted_35, _toDisplayString(u?.tahun), 1)
                        ]),
                        _createElementVNode("td", _hoisted_36, [
                          _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(formattedPrice)(u?.jumlah_donasi)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("span", _hoisted_40, [
                              _createElementVNode("button", {
                                class: "mx-2 px-2 rounded-md cursor-pointer",
                                onClick: _withModifiers(($event: any) => (editItem(u)), ["prevent"])
                              }, [
                                _createVNode(IcEdit)
                              ], 8, _hoisted_41),
                              _createElementVNode("button", {
                                type: "button",
                                class: "mx-2 px-2 rounded-md cursor-pointer",
                                onClick: _withModifiers(($event: any) => (deleteItem(u.id)), ["prevent"])
                              }, [
                                _createVNode(IcTrash)
                              ], 8, _hoisted_42)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("span", _hoisted_45, "Showing " + _toDisplayString(_unref(pagination)?.start) + " to " + _toDisplayString(_unref(pagination)?.end) + " of " + _toDisplayString(_unref(pagination)?.totalEntries) + " Entries", 1),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("button", {
            class: "px-4 py-2 text-sm font-semibold text-gray-800 bg-gray-300 rounded-l hover:bg-gray-400",
            disabled: page.value <= 1,
            onClick: _cache[2] || (_cache[2] = ()=>{page.value = _unref(pagination)?.currentPage - 1; getData()})
          }, " Prev ", 8, _hoisted_47),
          _createElementVNode("button", {
            class: "px-4 py-2 text-sm font-semibold text-gray-800 bg-gray-300 rounded-r hover:bg-gray-400",
            disabled: page.value >= _unref(pagination)?.totalPages,
            onClick: _cache[3] || (_cache[3] = ()=>{page.value = _unref(pagination)?.currentPage + 1; getData()})
          }, " Next ", 8, _hoisted_48)
        ])
      ])
    ])
  ]))
}
}

})